export const SHIPPING = 'shipping';
export const DEFAULT_PRICE = 100;

